import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="700pt" height="700pt" viewBox="0 0 700 500" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M259.17 100.8C193.994 100.8 154 157.796 154 204.55c0 101.09 114.9 194.92 196 254.65 81.102-59.734 196-153.57 196-254.65 0-46.75-39.996-103.75-105.17-103.75-36.398 0-67.496 29.02-90.828 56.59-23.332-27.57-54.43-56.59-90.828-56.59z" /></svg>;